import { IVariant } from "./variants";
import { IApplication } from "./applications";
import { IPlatform } from "./platform";

export interface IExperiments {
  data: IExperiment[];
  current_page: number;
  last_page: number;
  next_page_url?: string | null;
  prev_page_url?: string | null;
  total: number;
}

export enum ExperimentStatus {
  Draft = "draft",
  Active = "active",
  Stopped = "stopped",
}

export interface IExperiment {
  id: number;
  title: string;
  application_id: string;
  status: ExperimentStatus;
  target: string;
  description: string;
  key: string;
  custom_status: string;
  variants: IVariant[];
  platforms_ids: number[];
  created_at: string;
  start_date?: string | null;
  end_date?: string | null;
  application: IApplication;
  platforms: IPlatform[];
}

export interface IMatrixSignificance {
  [key: string]: {
    [key: string]: boolean | null;
  };
}
